import data from '../../../../configs/hotfoils.json';

export default class Hotfoil {
	static mapper(refinement) {
		if (!refinement) {
			return;
		}

		const { hotfoils } = data;

		for (let index = 0; index < hotfoils.length; index += 1) {
			const { properties } = hotfoils[index];

			if (properties.refinement === refinement) {
				return new Hotfoil(properties.refinement, properties.cssClass);
			}
		}

		return null;
	}

	constructor(refinement, cssClass) {
		this._refinement = refinement;
		this._cssClass = cssClass;
	}

	get refinement() {
		return this._refinement;
	}

	get cssClass() {
		return this._cssClass;
	}
}
